import io, { Socket } from "socket.io-client";
import { createContext, useContext, useEffect } from "react";
import config from "$services/config";
import { queryClient } from "$utils/queryClient";

import logger from "./logger";

const url = config.api_url;
// eslint-disable-next-line
let urlc = url.replaceAll("https://", "").trim();
const socket = io(urlc, {
  transports: ["websocket"],
  path: "/socket.io",
});

const SocketContext = createContext<Socket>(socket);
export const useSocket = () => useContext(SocketContext);

const SocketProvider = ({ children }: any) => {
  useEffect(() => {
    if (socket) {
      // defines action on message
      socket.on("invalidateQueriesServer", (data) => {
        data.map(async (d) => {
          await queryClient.invalidateQueries({
            queryKey: Array.isArray(d) ? d : [d],
            // Allow partial match of query keys !
            // (eg: the "getEntrepots" key will match the paginated keys : ["getEntrepots", {page: 1, rowsPerPage: 10}])
            // And thus will clean (invalidate) it !
            exact: false,
          });
          const queryCache = await queryClient.getQueryCache();
          const keys = await queryCache.getAll();
          const reg = `^${d}`;
          const startWith = new RegExp(reg);

          await Promise.all(
            keys.map(async ({ queryKey }) => {
              if (queryKey[0] === d || startWith.test(queryKey[0] as string)) {
                await queryClient.removeQueries({
                  queryKey,
                });
              }
            })
          );

          if (Array.isArray(d)) {
            await queryClient.removeQueries({
              queryKey: d,
            });
          }
        });
      });

      // Optional: Add error monitoring
      socket.on("error", (error) => {
        logger.error("Socket connection error:", error);
      });
    }
    return () => {
      socket.close();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}> {children} </SocketContext.Provider>
  );
};
export { SocketContext, SocketProvider };
